/**
 * DO NOT EDIT.
 *
 * This is Relay generated artifact.
 *
 * Please reach out to #jsm-cloud-megatron for any questions.
 *
 * @generated SignedSource<<0e647064fa46473d345b31b873f0fbe6>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { ReaderFragment, RefetchableFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type multiHcDropdownContentFragment$data = {
  readonly helpCenter: {
    readonly helpCenters: {
      readonly edges: ReadonlyArray<{
        readonly node: {
          readonly name?: {
            readonly default: string;
          } | null | undefined;
          readonly slug?: string | null | undefined;
        } | null | undefined;
      } | null | undefined> | null | undefined;
      readonly nodes: ReadonlyArray<{
        readonly __typename: string;
      } | null | undefined> | null | undefined;
      readonly pageInfo: {
        readonly endCursor: string | null | undefined;
        readonly hasNextPage: boolean;
      };
    } | null | undefined;
  } | null | undefined;
  readonly " $fragmentType": "multiHcDropdownContentFragment";
};
export type multiHcDropdownContentFragment$key = {
  readonly " $data"?: multiHcDropdownContentFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"multiHcDropdownContentFragment">;
};

import multiHcDropdownContentQuery_graphql from './multiHcDropdownContentQuery.graphql';

const node: ReaderFragment = (function(){
var v0 = [
  "helpCenter",
  "helpCenters"
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
};
return {
  "argumentDefinitions": [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "NUMBER_OF_HELP_CENTERS_PER_FETCH"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "SORT_ORDER"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "cloudId"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "cursor"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "workspaceAri"
    }
  ],
  "kind": "Fragment",
  "metadata": {
    "connection": [
      {
        "count": "NUMBER_OF_HELP_CENTERS_PER_FETCH",
        "cursor": "cursor",
        "direction": "forward",
        "path": (v0/*: any*/)
      }
    ],
    "refetch": {
      "connection": {
        "forward": {
          "count": "NUMBER_OF_HELP_CENTERS_PER_FETCH",
          "cursor": "cursor"
        },
        "backward": null,
        "path": (v0/*: any*/)
      },
      "fragmentPathInResult": [],
      "operation": multiHcDropdownContentQuery_graphql
    }
  },
  "name": "multiHcDropdownContentFragment",
  "selections": [
    {
      "alias": null,
      "args": [
        {
          "kind": "Variable",
          "name": "cloudId",
          "variableName": "cloudId"
        }
      ],
      "concreteType": "HelpCenterQueryApi",
      "kind": "LinkedField",
      "name": "helpCenter",
      "plural": false,
      "selections": [
        {
          "alias": "helpCenters",
          "args": [
            {
              "kind": "Variable",
              "name": "sortOrder",
              "variableName": "SORT_ORDER"
            },
            {
              "kind": "Variable",
              "name": "workspaceAri",
              "variableName": "workspaceAri"
            }
          ],
          "concreteType": "HelpCenterQueryResultConnection",
          "kind": "LinkedField",
          "name": "__multiHcDropdownContentFragment_helpCenters_connection",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "HelpCenterQueryResultEdge",
              "kind": "LinkedField",
              "name": "edges",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "concreteType": null,
                  "kind": "LinkedField",
                  "name": "node",
                  "plural": false,
                  "selections": [
                    {
                      "kind": "InlineFragment",
                      "selections": [
                        {
                          "alias": null,
                          "args": null,
                          "concreteType": "HelpCenterName",
                          "kind": "LinkedField",
                          "name": "name",
                          "plural": false,
                          "selections": [
                            {
                              "alias": null,
                              "args": null,
                              "kind": "ScalarField",
                              "name": "default",
                              "storageKey": null
                            }
                          ],
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "slug",
                          "storageKey": null
                        }
                      ],
                      "type": "HelpCenter",
                      "abstractKey": null
                    },
                    (v1/*: any*/)
                  ],
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "cursor",
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": null,
              "kind": "LinkedField",
              "name": "nodes",
              "plural": true,
              "selections": [
                (v1/*: any*/)
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "PageInfo",
              "kind": "LinkedField",
              "name": "pageInfo",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "endCursor",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "hasNextPage",
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Query",
  "abstractKey": null
};
})();

(node as any).hash = "5144b24d9ee22983239b35ac9f39443e";

export default node;
